import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import CheckoutInventory from 'components/Reports/CheckoutInventory';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <CheckoutInventory />
      </SiteContent>
    </ContentLayout>
  );
};
